import { useReducer } from "react";
import { modalAction, modalInitialState, modalReducer } from "./reducers";
import { studentCourseColumns } from "./constants";
import { CourseDetail } from "./components/CourseDetail";
import { useQuery } from "react-query";
import { CustomModal, ImageModal, NakedTable, ProtectedImg } from "components";
import { Button } from "reactstrap";
import apiService from "services/api";
import { AddCoursePurchaseModal } from "pages/Student/EditStudentPage/AddCoursePurchaseModal";

const StudentCourses = ({ student, refetch }) => {
  const [coursePurchaseModalProps, coursePurchaseModalDispatch] = useReducer(
    modalReducer,
    modalInitialState,
  );

  const { data: courses } = useQuery(
    ["studentCourses", student?.id],
    () => apiService.student.getCourses(student?.id),
    { enabled: !!student?.id },
  );

  const [lessonDetailModalProps, lessonDetailModalDispatch] = useReducer(
    modalReducer,
    modalInitialState,
  );

  const [addCoursePurchaseModalState, addCoursePurchaseModalDispatch] =
    useReducer(modalReducer, modalInitialState);

  const [signatureModalState, signatureModalDispatch] = useReducer(
    modalReducer,
    modalInitialState,
  );

  const showCoursePurchaseModal = (row) => {
    coursePurchaseModalDispatch({
      type: modalAction.OPEN,
      payload: row,
    });
  };

  const showLessonDetailModal = (row) => {
    lessonDetailModalDispatch({ type: modalAction.OPEN, payload: row });
  };

  return (
    <>
      <AddCoursePurchaseModal
        show={addCoursePurchaseModalState.show}
        studentId={student?.id}
        hideModal={() =>
          addCoursePurchaseModalDispatch({ type: modalAction.CLOSE })
        }
        refetch={refetch}
      />
      <CourseDetail
        student={student}
        refetch={refetch}
        showLessonDetailModal={showLessonDetailModal}
        lessonDetailModalProps={lessonDetailModalProps}
        lessonDetailModalDispatch={lessonDetailModalDispatch}
        coursePurchaseModalProps={coursePurchaseModalProps}
        coursePurchaseModalDispatch={coursePurchaseModalDispatch}
      />

      <Button
        size="sm"
        color="info"
        type="button"
        className="mb-3"
        onClick={() =>
          addCoursePurchaseModalDispatch({
            type: modalAction.OPEN,
            payload: student?.id,
          })
        }
      >
        Add Course Purchase
      </Button>

      <NakedTable
        data={courses || []}
        columns={studentCourseColumns(showCoursePurchaseModal)}
        title="Registered Courses"
      />
    </>
  );
};

export default StudentCourses;
